import { render, staticRenderFns } from "./env.vue?vue&type=template&id=5b0ca0e8"
import script from "./env.vue?vue&type=script&lang=js"
export * from "./env.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports